// Generates a per-request correlation ID that the backend echoes back in the
// X-Correlation-Id response header and records in its logs. Surfacing this ID
// in an error message lets a developer grep the exact request server-side.

export function generateCorrelationId() {
  // crypto.randomUUID is available in modern browsers over HTTPS/localhost.
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback for older browsers / insecure contexts.
  const random = Math.random().toString(36).slice(2, 10);
  return `corr_${Date.now()}_${random}`;
}

export default generateCorrelationId;
